import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'
import Offers from '@/views/Offers.vue'
import Details from '@/views/Details.vue'
import Enquire from '@/views/Enquire.vue'
import config from '../plugins/externalConfig'

Vue.use(Router);

let brand = '';
if (config.brand !== '') {
    brand = '-' + config.brand;
}

export default new Router({
    mode: 'history',
    base: process.env.VUE_APP_APP_BASE + brand,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/details/:slug',
            name: 'details',
            component: Details
        },
        {
            path: '/offers/:type',
            name: 'offers',
            component: Offers,
            props: true,
        },
        {
            path: '/enquire/',
            name: 'enquire',
            component: Enquire
        },
        {
            //404 - redirect to main site's 404
            path: '*',
            beforeEnter() {
                window.location = 'https://www.vwfsfleet.co.uk/404';
            }
        }
    ]
})
